import { defineComponent } from '~/scripts/utils/alpine'
import { scrollTo } from '~/scripts/utils/scroll'

type Step = 0 | 1 | 2

type Code = number
type Center = number
type Treatment = number
type Relationships = Record<Treatment, Record<Center, Code[]>>

export default defineComponent(() => ({
  treatment: undefined as number | undefined,
  center: undefined as number | undefined,
  currentStep: 0 as Step,
  relationships: {} as Relationships,
  get isCosmetic(): boolean {
    if (!this.treatment) {
      return false
    }

    return (
      this.$root.dataset.cosmeticsTreatments
        ?.split(',')
        .includes(this.treatment.toString()) ?? false
    )
  },
  // List of available centers for the current treatment.
  get centers(): Center[] {
    const { treatment } = this
    if (!treatment) {
      return []
    }
    return Object.keys(this.relationships[treatment] ?? {}).map<Center>(Number)
  },
  init() {
    this.relationships = JSON.parse(this.$root.dataset.relationships ?? '{}')

    // Treatment can already be set from the URL.
    const params = new URLSearchParams(globalThis.location.search)
    if (params.has('service')) {
      this.treatment = Number(params.get('service'))
    }

    if (this.treatment) {
      this.updateStep()
    }

    this.$watch('treatment', () => {
      globalThis.history.replaceState(
        undefined,
        '',
        `?service=${this.treatment}`,
      )
    })

    this.$watch('currentStep', () => {
      scrollTo(this.$root, { duration: 0.7 })
    })
  },
  selectTreatment(treatment: number) {
    this.treatment = treatment
    this.center = undefined
    this.updateStep()
  },
  selectCenter(center: number) {
    this.center = center
    this.updateStep()
  },
  async updateStep() {
    if (this.center) {
      this.currentStep = 2
      await this.$nextTick()
      this.loadIframes()
      return
    }
    if (this.treatment) {
      this.currentStep = 1
      return
    }
  },
  loadIframes() {
    const iframes = document.body.querySelectorAll<HTMLIFrameElement>(
      `[data-treatment="${this.treatment}"][data-center="${this.center}"] iframe.od-widget`,
    )

    for (const iframe of iframes) {
      if (iframe.dataset.src) {
        iframe.src = iframe.dataset.src
      }
    }
  },
}))
